import { useQuery } from '@tanstack/react-query';

import { useRouterQuery } from '~hooks/useRouterQuery';
import { useSuspendedQuery } from '~hooks/useSuspenseQuery/useSuspenseQuery';
import { fetcher } from '~lib/api/fetch';
import type { CompanyBase, CompanyInfo } from '~types/company';

import QueryKeys from '../queryKeys';

export interface CompanyInfoResponse extends CompanyBase, CompanyInfo {}

const getUrl = (companyHash?: string | null) => `/api/company/${companyHash}/info`;

export default function useGetCompanyInfo(companyHash?: string | null) {
  return useQuery<CompanyInfoResponse>(
    [QueryKeys.companyInfo, companyHash],
    () => fetcher(getUrl(companyHash)),
    { enabled: !!companyHash },
  );
}

export function useSuspensedCompanyInfo() {
  const companyId = useRouterQuery('companyId');

  return useSuspendedQuery<CompanyInfoResponse>(
    [QueryKeys.companyInfo, companyId],
    () => fetcher(getUrl(companyId)),
    { enabled: !!companyId },
  );
}
